module.exports = "<div class=\"container d-flex flex-column offset-lg-1\">\n  <div class=\"row\">\n    <h2>Conference costs</h2>\n  </div>\n  <div class=\"offset-lg-1\">\n    <p>The conference fee is <b>400 EUR</b>.</p>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/rzonsol/WebstormProjects/ammpb2/src/app/fee/fee.component.html
// module id = ../../../../../src/app/fee/fee.component.html
// module chunks = main